import * as helper from './../../../Assets/Js/helper';
import VideoPlayer from './VideoPlayer';
import DialogManager from './DialogManager';
import * as Events from './Events';
import MessageManager from './MessageManager';

export default class Chatsim {
	constructor(cdnDomain) {
		this.options = {
			promoLocation: '//' + cdnDomain,
			playerId: 'chatSimVideo',
			aspectRatio: 3 / 4,
			maxVideoWidth: 1215,
			muted: 0,
			startCommand: 'startSeq',
			btnContainer: '#chat ul',
			selChatWindow: '#chat ul',
			version: 'noFullScreen',
			versionNumber: 0,
			isSafari: false,
			location: false,
			clearCacheOnEachStep: false,
			supportsCors: (function browserSupportsCors() {
				if ('withCredentials' in new XMLHttpRequest()) {
					return true;
				} else { //noinspection JSUnresolvedVariable
					return !!window.XDomainRequest;
				}
			})(),
			mobile: false,
			signupBtnHeight: 50,
			timingAmendment: 2200,
			onInit: [],
			onSignup: [],
			onDialogChoice: []
		};

		this._playlist = {
			daytime: '',
			complement: '',
			chat: {
				action: '',
				performer: '',
				widescreen: '',
				state: [
					{
						id: '',
						video: {
							src: '',
							action: ''
						},
						messages: {
							message: [
								{
									delay: '',
									$: ''
								}
							]
						},
						clientAnswers: {
							delay: '',
							answer: {
								action: '',
								$: ''
							}
						}
					}
				]
			}
		};

		this.videoPlayer = null;
		this.messageHandler = null;
		this.useWideScreen = false;
		this.runningTimeouts = [];
		this.runningScene = '';
		this.cta = {
			actionsClicked: 0,
			clipExists: false,
			isActive: false,
			previousCommand: ''
		};
	}

	/**
	 * Initiate the player
	 *
	 * @param {object} playlist
	 * @param {object} options
	 */
	init(playlist, options) {
		helper.deepExtend(this.options, options);

		this.videoPlayerElement = document.getElementById('chatSimVideo');
		this.videoPlayer = new VideoPlayer(this.videoPlayerElement, document.getElementById('soundBtn'), this.options.promoLocation);
		this.dialogManager = new DialogManager(
			document.querySelector(this.options.btnContainer),
			document.querySelector(this.options.selChatWindow),
			this.options.version,
			this.options.clearCacheOnEachStep, 'Gast' + (Math.ceil(Math.random() * 78) + 23)
		);

		helper.addEventListener(window, Events.NEXT_ACTION, function (evt) {
			this._doNextAction(evt.detail.action);
		}.bind(this));

		this.changePlaylist(playlist);
	}

	/**
	 * Switch to a new playlist
	 *
	 * @param {object} playlist
	 */
	changePlaylist(playlist) {
		this._playlist = playlist;
		if (this.messageHandler !== null) {
			this.messageHandler.reset();
		}
		this.messageHandler = new MessageManager(this.options.selChatWindow, this.options.version, playlist.chat.performer, this.options.timingAmendment);

		let testCta = this._getStateById('ctaClip');
		this.cta.clipExists = testCta.id === 'ctaClip';
		this.cta.actionsClicked = 0;
		this.cta.isActive = false;
		this.cta.previousCommand = '';

		this.dialogManager.reset();

		this.videoPlayer.wideScreen = playlist.chat.hasOwnProperty('widescreen') &&
			parseInt(playlist.chat.widescreen) === 1 &&
			this.options.version === 'fullscreen' &&
			screen.width / screen.height === 16 / 9;

		this.runningScene = '';

		let firstAction = this.options.startCommand;
		if (firstAction === 'startSeq' && this.options.version === 'noFullScreen') {
			firstAction = 'welcome';
		}

		this._doNextAction(firstAction);
	}

	_doVideo(state) {
		this.runningScene = state.id;
		if (state.id === 'ctaClip') {
			this.cta.isActive = true;
			helper.one(window, 'accountCreated', this._onAccountCreated.bind(this));
		}
		this.videoPlayer.nextVideo(state.video);
		this.messageHandler.setMessages(this._getSenderMessagesFromState(state));
		this.dialogManager.addButtons(this._getButtonsFromState(state));
	}

	_onAccountCreated() {
		this.cta.isActive = false;
		this.dialogManager.removeButtons();
		this._doNextAction(this.cta.previousCommand);
	}

	_doNextAction(action) {
		if (this.options.showCta > 0 && this.cta.clipExists && this.cta.actionsClicked === this.options.showCta && this.cta.isActive === false) {
			this.cta.previousCommand = action;
			action = 'ctaClip';
		}

		if (action === 'callback: signup') {
			helper.triggerEvent(window, 'signUp');
		}

		if (action === 'ex:chatEnd') {
			helper.triggerEvent(window, 'signUp');
		}

		let state = this._getStateById(action);

		if (state.id === this.runningScene) {
			this.videoPlayer.repeat();
		} else if (state.id !== 'notFound') {
			this._doVideo(state);
		}
	}

	/**
	 * Gets a state from the playlist. Returns an Object with id "notFound" if state does not exist
	 *
	 * @param {string} id
	 * @returns {Object}
	 * @private
	 */
	_getStateById(id) {
		for (let i = 0; i < this._playlist.chat.state.length; i++) {
			if (this._playlist.chat.state[i].id === id) {
				return this._playlist.chat.state[i];
			}
		}

		return {id: 'notFound'};
	}

	/**
	 * Get Client Messages from State. Always returns an array ob messages, even if there is only one.
	 *
	 * Might return an empty array, if there is no message.
	 *
	 * @param state
	 * @returns {Array}
	 * @private
	 */
	_getSenderMessagesFromState(state) {
		let messages = [];

		if (state.hasOwnProperty('messages')) {
			let mine = state.messages.message;
			if (Array.isArray(mine)) {
				messages = mine;
			} else {
				messages.push(mine);
			}
		}

		return messages;
	}

	/**
	 * Gets the list of clickable buttons for a state (if any)
	 *
	 * Normalizes the answers so there is always a delay (eben if it is just 0) and that the answer key
	 * always contains an array, even if there is only 1 answer.
	 *
	 * @param {Object} state
	 * @returns {Object}
	 * @private
	 */
	_getButtonsFromState(state) {
		let buttons = {delay: 0, answer: []};
		if (state.hasOwnProperty('clientAnswers')) {
			buttons.delay = typeof state.clientAnswers.delay === 'undefined' ? 0 : parseInt(state.clientAnswers.delay);

			if (Array.isArray(state.clientAnswers.answer)) {
				buttons.answer = state.clientAnswers.answer;
			} else {
				// normalize to array
				buttons.answer = [state.clientAnswers.answer];
			}
		}

		return buttons;
	}
}
